require('./ctxtextpath.js');
var spp = require('./path-properties.min.js');
const { applyInnerText } = require('../inner-text');

fabric.PathIText = fabric.util.createClass(fabric.Text, {
    type: 'path-itext',

    cacheProperties: fabric.Text.prototype.cacheProperties.concat(
        'prefix',
        'suffix',
        'betweenCharacters',
        'betweenWords',
        'startAngle',
        'endAngle',
        'strokeWidth',
        'opentypeStroke',
        'tracking',
        'convex',
        'pathWidth',
        'lockAngleControls',
        'minSizePx',
        'maxSizePx'
    ),

    width: 1,
    height: 1,
    caps: false,

    path: null,
    pathProperties: null,

    pathWidth: 1,
    pathColor: '#ff0000',
    currentLineHeight: 1,
    fontFamily: 'Arial',
    textAlign: 'center',
    convex: false,
    tracking: 0,
    prefix: '',
    suffix: '',
    betweenCharacters: '',
    betweenWords: '',

    lockUniScalingWithSkew: false,

    // Circle properties
    verticalDiameter: 1,
    horizontalDiameter: 1,

    // Stroke
    stroke: '#000000',
    strokeWidth: 0,
    opentypeStrokeWidth: 0,
    opentypeStroke: '#000000',

    // Min and max angles to render the text between them
    startAngle: 315,
    endAngle: 45,
    lockAngleControls: false,

    minSizePx: 0,

    _startArcOffset: 0,
    _endArcOffset: 0,
    /**
     * Arc length where the text is contained
     */
    _maxTextArcLength: 0,
    _pathLength: 0,
    __lastDrawnData: [],

    CACHE_FONT_SIZE: 200,

    // Angle marker controls related
    _angleControlsCords: {},
    _lockMovementXBackup: false,
    _lockMovementYBackup: false,
    _draggingAngleControl: null,

    initialize: function (text, options) {
        options.objectCaching = true; // Caching is always enabled for this object
        options.noScaleCache = false; // Update cache during scaling

        this.setRadius(options.horizontalDiameter / 2, options.verticalDiameter / 2);

        // Set the font family before anything else to ensure the font is found in opentype
        this.fontFamily = options.fontFamily || this.fontFamily;
        this.maxSizePx = options.maxSizePx || options.fontSize || this.fontSize;
        options.path = null;

        // Call super constructor
        this.callSuper('initialize', text, options);

        this.on({
            added: function () {
                this.cornerSize = 0.025 * this.canvas.width;
            },
            scaling: function (event) {
                // Only allow proportional scaling but allowing skew
                if (this.lockUniScalingWithSkew) {
                    let scale = 1;
                    if (event.transform.action === 'scaleX') {
                        scale = this.scaleX;
                    } else {
                        scale = this.scaleY;
                    }

                    this.scaleX = scale;
                    this.scaleY = scale;
                }

                this.updateFromGroupScaling();
            },
            selected: function () {
                // Set object as dirty so angle markers controls are updated
                this.dirty = true;
            },
            deselected: function () {
                // Set object as dirty so angle markers controls are updated
                this.dirty = true;
            },
            mousedown: function (event) {
                if (this.lockAngleControls) {
                    return;
                }

                var point = this.getLocalPointer(event);
                this._draggingAngleControl = this._isPointInMarkerControl(point);

                // Disable object dragging if trying to move the angle markers controls
                if (this._draggingAngleControl) {
                    this._lockMovementXBackup = this.lockMovementX;
                    this._lockMovementYBackup = this.lockMovementY;
                    this.lockMovementX = true;
                    this.lockMovementY = true;
                }
            },
            mouseup: function () {
                if (this.lockAngleControls) {
                    return;
                }

                if (this._draggingAngleControl) {
                    // Restore movement lock
                    this.lockMovementX = this._lockMovementXBackup;
                    this.lockMovementY = this._lockMovementYBackup;
                }
                this._draggingAngleControl = null;
            },
            mousemove: function (event) {
                if (this.lockAngleControls) {
                    return;
                }

                if (
                    this._angleControlsCords &&
                    this._angleControlsCords.start &&
                    this._angleControlsCords.end &&
                    this.canvas._activeObject === this
                ) {
                    if (this._draggingAngleControl) {
                        // Calculate the angle between the pointer and the center of the object
                        var point = this.getLocalPointer(event);
                        var angle = Math.atan2(point.y - this.height / 2, point.x - this.width / 2) + Math.PI / 2;

                        if (this._draggingAngleControl.indexOf('start') > -1) {
                            this.set('startAngle', fabric.util.radiansToDegrees(angle));
                        } else if (this._draggingAngleControl.indexOf('end') > -1) {
                            this.set('endAngle', fabric.util.radiansToDegrees(angle));
                        }

                        this.fire('modified', this);
                        this.canvas.renderAll();
                    } else {
                        // Get mouse coordinates relative to the object
                        // eslint-disable-next-line no-redeclare
                        var point = this.getLocalPointer(event);

                        if (this._isPointInMarkerControl(point)) {
                            event.target.hoverCursor = 'crosshair';
                        } else {
                            event.target.hoverCursor = this.canvas.moveCursor;
                        }
                    }
                }
            }
        });
    },

    /**
     * Check if a point is inside the square
     * @param {Number} x center x coordinate of the square
     * @param {Number} y center y coordinate of the square
     * @param {Number} size rectangle side length
     * @param {Object} point point to check if it's inside the square
     * @param {Number} angle angle of rotation of the square in radians
     */
    _isPointInControlSquare: function (x, y, size, point, angle) {
        var rotatePointAroundPoint = function (point, centerOfRotationPoint, angle) {
            var sinus = Math.sin(angle);
            var cosinus = Math.cos(angle);

            // Distance between points
            var dx = point.x - centerOfRotationPoint.x;
            var dy = point.y - centerOfRotationPoint.y;
            var d = Math.sqrt(dx * dx + dy * dy);

            // Calculate the new X,Y coordinates for the rotated point
            var tempX = d * cosinus;
            var tempY = d * sinus;

            var rX = tempX + centerOfRotationPoint.x;
            var rY = tempY + centerOfRotationPoint.y;

            return new fabric.Point(rX, rY);
        };
        point = rotatePointAroundPoint(point, new fabric.Point(x, y), angle);

        return point.x > x - size / 2 && point.x < x + size / 2 && point.y > y - size / 2 && point.y < y + size / 2;
    },

    _isPointInMarkerControl: function (point) {
        if (this._angleControlsCords && this._angleControlsCords.start && this._angleControlsCords.end && point) {
            // Detect if cursor is inside any of the controls from the angle markers
            if (
                this._isPointInControlSquare(
                    this._angleControlsCords.start.upper.x,
                    this._angleControlsCords.start.upper.y,
                    this._angleControlsCords.start.size,
                    point,
                    this._angleControlsCords.start.angle
                )
            ) {
                return 'start_upper';
            } else if (
                this._isPointInControlSquare(
                    this._angleControlsCords.start.lower.x,
                    this._angleControlsCords.start.lower.y,
                    this._angleControlsCords.start.size,
                    point,
                    this._angleControlsCords.start.angle
                )
            ) {
                return 'start_lower';
            } else if (
                this._isPointInControlSquare(
                    this._angleControlsCords.end.upper.x,
                    this._angleControlsCords.end.upper.y,
                    this._angleControlsCords.end.size,
                    point,
                    this._angleControlsCords.end.angle
                )
            ) {
                return 'end_upper';
            } else if (
                this._isPointInControlSquare(
                    this._angleControlsCords.end.lower.x,
                    this._angleControlsCords.end.lower.y,
                    this._angleControlsCords.end.size,
                    point,
                    this._angleControlsCords.end.angle
                )
            ) {
                return 'end_lower';
            } else {
                return false;
            }
        }
        return false;
    },

    /**
     * This method is intended to be called after the object was modified with a group
     *  selection. On fabric.js, elements events are not fired when inside a group, that's
     *  why this method must be called manually after exiting group selection
     */
    updateFromGroupScaling: function () {
        const w = this.horizontalDiameter * this.scaleX,
            h = this.verticalDiameter * this.scaleY;

        this.scaleX = 1;
        this.scaleY = 1;

        this.setRadius(w / 2, h / 2);
    },

    /**
     * Return a context for measurement of text string.
     * if created it gets stored for reuse
     * @param {String} text Text string
     * @param {Object} [options] Options object
     * @return {fabric.Text} thisArg
     */
    getMeasuringContext: function () {
        // if we did not return we have to measure something.
        if (!fabric._measuringContext) {
            fabric._measuringContext =
                (this.canvas && this.canvas.contextCache) || fabric.util.createCanvasElement().getContext('2d');
        }

        fabric._measuringContext.opentypeStrokeWidth = this.opentypeStrokeWidth;
        fabric._measuringContext.opentypeStroke = this.opentypeStroke || this.stroke;
        fabric._measuringContext.lineSpacing = 1;

        return fabric._measuringContext;
    },

    getPathWidth: function () {
        return this.horizontalDiameter;
    },

    getPathHeight: function () {
        return this.verticalDiameter;
    },

    /**
     * Generates a path describing an ellipse
     * @param {Number} cx   X center of the ellipse
     * @param {Number} cy   Y center of the ellipse
     * @param {Number} a    Horizontal radius
     * @param {Number} a    Vertical radius
     */
    _generateEllipse: function (cx, cy, a, b) {
        var d =
            'M' +
            (cx - a) +
            ',' +
            cy +
            ' a' +
            a +
            ',' +
            b +
            ' 0 1,0 ' +
            2 * a +
            ',0 a' +
            a +
            ',' +
            b +
            ' 0 1,0 ' +
            -2 * a +
            ',0';
        return d;
    },

    /**
     * This method is the same as doing Math.atan(w/h * Math.tan(angle)). The problem is this expression
     *  doesn't always shield the right result.
     * See: https://stackoverflow.com/questions/52149077/what-does-startangle-mean-in-an-html5-canvas-ellipse
     * See: https://math.stackexchange.com/questions/2116622/what-is-the-arctangent-of-tangent
     * @param {Number} angle angle in radians
     * @param {Number} w width
     * @param {Number} h height
     */
    _atanTan: function (angle, w, h) {
        angle = ((angle + Math.PI) % (2 * Math.PI)) - Math.PI;
        var tempAngle = angle;
        angle = Math.atan((w / h) * Math.tan(angle));
        if (tempAngle < -Math.PI / 2) {
            angle -= Math.PI;
        } else if (tempAngle > Math.PI / 2) {
            angle += Math.PI;
        }
        return angle;
    },

    /**
     * Compute the length of the arc between the given angles using the Riemman sum to approximate
     *  the integral
     * @param {Number} angle1 starting angle
     * @param {Number} angle2 ending angle
     * @param {Number} a ellipse horizontal radius
     * @param {Number} b ellipse vertical radius
     * @param {Number} segments number of division for the Riemman sum
     */
    _getEllipseArcLength: function (angle1, angle2, a, b, segments = 360) {
        // Convert theta to phi: http://www.petercollingridge.co.uk/tutorials/computational-geometry/finding-angle-around-ellipse/
        if (angle1 != 360) {
            angle1 = fabric.util.radiansToDegrees(this._atanTan(fabric.util.degreesToRadians(angle1), b, a));
        }

        if (angle2 != 360) {
            angle2 = fabric.util.radiansToDegrees(this._atanTan(fabric.util.degreesToRadians(angle2), b, a));
        }

        angle1 = this._normalizeAngle(angle1);
        angle2 = this._normalizeAngle(angle2);

        var delta = fabric.util.degreesToRadians(angle2 - angle1) / segments;
        var angle = fabric.util.degreesToRadians(angle1);
        var sum = 0;

        for (var n = 0; n < segments; ++n) {
            // Compute the Riemman sum of the complete elliptic integral of the second kind
            // https://en.wikipedia.org/wiki/Elliptic_integral#Complete_elliptic_integral_of_the_second_kind
            // https://mathworld.wolfram.com/EllipticIntegraloftheSecondKind.html
            var m = 1 - (b * b) / (a * a);
            var term = m * Math.pow(Math.sin(angle), 2);
            var res = Math.sqrt(Math.abs(1 - term));
            sum += res;

            angle += delta;
        }

        let length = sum * delta * a;
        if (Number.isNaN(length)) {
            length = 0;
        }

        return length;
    },

    _computeArcs: function () {
        // Calculate the offset from the starting angle
        this._startArcOffset = this._getEllipseArcLength(
            this.startAngle,
            360,
            this.horizontalDiameter / 2,
            this.verticalDiameter / 2
        );

        // Calculate the offset from the ending angle
        this._endArcOffset = this._getEllipseArcLength(
            0,
            360 - this.endAngle,
            this.horizontalDiameter / 2,
            this.verticalDiameter / 2
        );

        // Calculate the max arc length between the angles
        this._maxTextArcLength = Math.abs(
            this._getEllipseArcLength(
                this.startAngle,
                this.endAngle,
                this.horizontalDiameter / 2,
                this.verticalDiameter / 2
            )
        );

        if (this.convex) {
            this._maxTextArcLength = this._pathLength - this._maxTextArcLength;
        }

        if (this.startAngle > this.endAngle) {
            this._maxTextArcLength = this._pathLength - this._maxTextArcLength;
        }

        if (this.startAngle === this.endAngle) {
            this._maxTextArcLength = Math.abs(
                this._getEllipseArcLength(0, 360, this.horizontalDiameter / 2, this.verticalDiameter / 2)
            );
        }
    },

    setRadius: function (a, b) {
        // If only one radius is provided, make the other the same
        if (!a && b) {
            a = b;
        }
        if (!b && a) {
            b = a;
        }

        // Make sure we can't have negative or 0 radius
        a = a < 0 ? 0.1 : a;
        b = b < 0 ? 0.1 : b;

        this.horizontalDiameter = 2 * a;
        this.verticalDiameter = 2 * b;

        // Create the path that describes the ellipse
        var d = this._generateEllipse(0, 0, a, b);
        this.set('width', this.getPathWidth() + this.currentLineHeight * 1.1);
        this.set('height', this.getPathHeight() + this.currentLineHeight * 1.1);

        this.pathProperties = spp.svgPathProperties(d);
        //this.path = d;
        this._pathLength = this._getEllipseArcLength(0, 360, this.horizontalDiameter / 2, this.verticalDiameter / 2);

        // Recalculate arcs after changing radius
        this._computeArcs();
    },

    /**
     * Return the dimension and the zoom level needed to create a cache canvas
     * big enough to host the object to be cached.
     * @private
     * @return {Object}.width width of canvas
     * @return {Object}.height height of canvas
     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
     */
    _getCacheCanvasDimensions: function () {
        var dim = this.callSuper('_getCacheCanvasDimensions');

        dim.width += this.width * dim.zoomX;
        dim.height += this.height * dim.zoomY;

        return dim;
    },

    _normalizeAngle: function (angle) {
        angle = angle || 0;

        // Exact multiple of 360 degrees
        if (angle !== 0 && angle % 360 === 0) {
            angle = 360;
        } else {
            // Make sure the angle is between 0 and 360 degrees
            angle = angle % 360;
        }

        // Wrap around negative angles
        if (angle < 0) {
            angle = 360 + angle;
        }

        return angle;
    },

    /**
     * Sets specified property to a specified value
     * @param {String} key
     * @param {*} value
     * @return {fabric.Text} thisArg
     * @chainable
     */
    _set: function (key, value) {
        if (['fontFamily', 'fontSize', 'maxSizePx', 'minSizePx'].includes(key)) {
            if (key === 'fontFamily') {
                // Add quotes around the font name to avoid issues
                // Read more about this tricky world of the fonts here: https://mathiasbynens.be/notes/unquoted-font-family
                if (value.indexOf("'") < 0) {
                    value = "'" + value + "'";
                }
            }
            this.callSuper('_set', key, value);

            // Compute the line height
            const ctx = this.getMeasuringContext();
            const charStyle = this.getCompleteStyleDeclaration(0, 0);

            this._setTextStyles(ctx, charStyle, true);

            const fontMultiplier = charStyle.fontSize / this.CACHE_FONT_SIZE;

            this.currentLineHeight = _measureTextOpentype.call(ctx, ' ').fontHeight * fontMultiplier;

            // Now with the height calculate the max possible height when the glyph is rotated,
            //  that is when it is at 45 degrees
            this.currentLineHeight = this.currentLineHeight / Math.sin(Math.PI / 4);
            return;
        }

        if (['startAngle', 'endAngle'].includes(key)) {
            value = this._normalizeAngle(value);
            this.callSuper('_set', key, value);

            // Recalculate arcs after changing angles
            this._computeArcs();
            return;
        }

        const functions = {
            caps: () => {
                if (!value) return;
                this.set('text', this.text.toUpperCase());
            },
            text: () => {
                if (!this.caps) return;
                value = value.toUpperCase();
            },
            strokeWidth: () => {
                this.set('opentypeStrokeWidth', value);
                this._computeArcs();
            },
            textAlign: () => {
                // Recalculate arcs after changing text alignment
                this.callSuper('_set', key, value);
                this._computeArcs();
            },
            horizontalDiameter: () => this.setRadius(value / 2, this.verticalDiameter / 2),
            verticalDiameter: () => this.setRadius(this.horizontalDiameter / 2, value / 2),
            convex: () => {
                this.callSuper('_set', key, value);
                this._computeArcs();
            }
        };

        functions[key]?.();

        this.callSuper('_set', key, value);
    },

    getFontSize: function () {
        return this.fontSize;
    },

    /**
     * Initialize or update text dimensions.
     * Updates this.width and this.height with the proper values.
     * Does not return dimensions.
     */
    initDimensions: function () {
        this.callSuper('initDimensions');
        this.width = this.getPathWidth() + this.currentLineHeight * 1.1;
        this.height = this.getPathHeight() + this.currentLineHeight * 1.1;
    },

    _wrapDistanceAroundPath: function (currentDistance, pathDistance) {
        if (currentDistance > pathDistance - 0.00001) {
            currentDistance = currentDistance - pathDistance;
        } else if (currentDistance < 0) {
            currentDistance = pathDistance + currentDistance;
        }

        return currentDistance;
    },

    /**
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderAngleMarkers: function (ctx, drawControls) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var scope = this;
        if (!this.pathProperties) {
            return;
        }

        // Don't render markers if the path is not drawn either
        if (this.pathWidth <= 0) {
            return;
        }

        var getAngleBetweenPoints = function (p1, p2) {
            // Get the angle in a point half way the character
            var angle = Math.atan2(p1.y - p2.y, p1.x - p2.x);
            return angle;
        };

        var renderLinePerpendicularToPoint = function (
            ctx,
            point,
            tangentAngle,
            lineLength,
            drawControl,
            controlSize,
            type
        ) {
            var canvasScaling = 1 / scope.canvas.viewportTransform[0];

            lineLength *= canvasScaling;
            controlSize *= canvasScaling;
            var controlsLineWidth = 2 * canvasScaling;

            // Calculate the delta x and y for the second point of the line which first point
            //  is at the given 'point' (method argument). When rendering a line between
            //  (point) and (dx, dy) a perpendicular line to the given tangent is drawn
            var dx = (lineLength / 2) * Math.cos(Math.PI / 2 - tangentAngle);
            var dy = (lineLength / 2) * Math.sin(Math.PI / 2 - tangentAngle);

            ctx.save();

            // Line styles
            ctx.strokeStyle = scope.pathColor;
            ctx.lineWidth = scope.pathWidth;

            // Move the origin to the starting point for the lines. We draw the lines in two half,
            //  first half below the tangent line and the second half above the tangent line
            ctx.translate(point.x, point.y);
            ctx.beginPath();

            // Draw lower part of the line
            ctx.moveTo(0, 0);
            ctx.lineTo(-dx, dy);

            // Draw upper part of the line
            ctx.moveTo(0, 0);
            ctx.lineTo(dx, -dy);

            ctx.stroke();

            // Draw controls if requested
            if (drawControl) {
                ctx.lineWidth = controlsLineWidth;
                ctx.strokeStyle = scope.cornerStrokeColor || scope.cornerColor;

                // Draw upper control
                ctx.save();
                ctx.translate(dx, -dy);
                ctx.rotate(tangentAngle);
                ctx.strokeRect(-(controlSize / 2), -(controlSize / 2), controlSize, controlSize);
                ctx.restore();

                // Draw lower control
                ctx.save();
                ctx.translate(-dx, dy);
                ctx.rotate(tangentAngle);
                ctx.strokeRect(-(controlSize / 2), -(controlSize / 2), controlSize, controlSize);
                ctx.restore();

                // Store the coordinates where the rectangles where drawn so we can detect when mouse pointer is
                //  over them and react to events.
                scope._angleControlsCords[type] = {
                    upper: {
                        x: point.x + scope.width / 2 + dx - 2 * controlsLineWidth,
                        y: point.y + scope.height / 2 - dy
                    },
                    lower: {
                        x: point.x + scope.width / 2 - dx - 2 * controlsLineWidth,
                        y: point.y + scope.height / 2 + dy
                    },
                    size: controlSize + controlsLineWidth * 2,
                    angle: tangentAngle
                };
            }

            ctx.restore();
        };

        var polarToCartesian = function (centerX, centerY, a, b, angleInDegrees) {
            angleInDegrees = scope._normalizeAngle(angleInDegrees);
            var radAngle = fabric.util.degreesToRadians(angleInDegrees);
            var factor = radAngle < Math.PI / 2 && radAngle > -Math.PI / 2 ? 1 : -1;

            var x = (a * b) / Math.sqrt(b * b + a * a * Math.pow(Math.tan(radAngle), 2));
            x *= factor;
            var y = (a * b) / Math.sqrt(a * a + (b * b) / Math.pow(Math.tan(radAngle), 2));

            return {
                x: (centerX + x) * (angleInDegrees >= 0 && angleInDegrees <= 270 ? 1 : -1),
                y: (centerY + y) * (angleInDegrees >= 0 && angleInDegrees <= 180 ? 1 : -1)
            };
        };

        // Render start and end angle markers
        var startAnglePoint = polarToCartesian(
            0,
            0,
            this.horizontalDiameter / 2,
            this.verticalDiameter / 2,
            this.startAngle - 90
        );
        var endAnglePoint = polarToCartesian(
            0,
            0,
            this.horizontalDiameter / 2,
            this.verticalDiameter / 2,
            this.endAngle - 90
        );
        var startMarkerAngle = getAngleBetweenPoints(
            startAnglePoint,
            polarToCartesian(
                0,
                0,
                this.horizontalDiameter / 2,
                this.verticalDiameter / 2,
                this.startAngle - 90 - 0.0001
            )
        );
        var endMarkerAngle = getAngleBetweenPoints(
            endAnglePoint,
            polarToCartesian(0, 0, this.horizontalDiameter / 2, this.verticalDiameter / 2, this.endAngle - 90 - 0.0001)
        );

        renderLinePerpendicularToPoint(
            ctx,
            startAnglePoint,
            startMarkerAngle,
            60,
            drawControls,
            this.cornerSize,
            'start'
        );
        renderLinePerpendicularToPoint(ctx, endAnglePoint, endMarkerAngle, 60, drawControls, this.cornerSize, 'end');
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function (ctx) {
        // Call the default renderer
        this.callSuper('_render', ctx);
        this._renderAngleMarkers(ctx, this.canvas._activeObject === this && !this.lockAngleControls);
    },

    /**
     * return height of char in fontSize for a character at lineIndex, charIndex
     * @param {Number} l line Index
     * @param {Number} c char index
     * @return {Number} fontSize of that character
     */
    getHeightOfChar: function (l, c) {
        var ctx = this.getMeasuringContext();
        if (this._textLines[l][c]) {
            var scaling = this.getValueOfPropertyAt(l, c, 'fontSize') / this.CACHE_FONT_SIZE;
            var info = _measureTextOpentype.call(ctx, this._textLines[l][c]);
            return info.height * scaling;
        } else {
            return this.getValueOfPropertyAt(l, c, 'fontSize');
        }
    },

    _offsetY: 0,
    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {String} method Method name ("fillText" or "strokeText")
     */
    _renderTextCommon: function (ctx, method) {
        var lineHeights = 0;
        var left = -this.width / 2;
        var metrics = [];
        var lineHeightsStory = [];

        ctx.opentypeStroke = this.opentypeStroke || this.stroke;
        ctx.opentypeStrokeWidth = this.opentypeStrokeWidth;
        ctx.fillStyle = this.fill || this.color;

        // We don't support ligatures on path text as every letter is rendered individually
        ctx.ligatures = false;

        for (let i = 0, len = this._textLines.length; i < len; i++) {
            let heightOfLine,
                leftOffset = 0;

            const metric = _measureTextOpentype.call(ctx, this._textLines[i].join(''));
            leftOffset += this.opentypeStrokeWidth / 2;
            heightOfLine = metric.fontHeight;
            lineHeightsStory[i] = heightOfLine;

            if (i > 0) {
                lineHeights += lineHeightsStory[i - 1];
            }
            const info = this._renderTextLine(
                method,
                ctx,
                this._textLines[i],
                left + leftOffset,
                lineHeights - this.opentypeStrokeWidth / 2,
                i
            );

            if (info) {
                metrics.push(info);
            }
        }
    },

    /**
     * @private
     * @param {String} method Method name ("fillText" or "strokeText")
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {String} line Text to render
     * @param {Number} left Left position of text
     * @param {Number} top Top position of text
     * @param {Number} lineIndex Index of a line in a text
     */
    _renderTextLine: function (method, ctx, line, left, top, lineIndex) {
        return this._renderChars(method, ctx, line, left, top, lineIndex);
    },

    /**
     * @param {String} method
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {String} line Content of the line
     * @param {Number} left
     * @param {Number} top
     * @param {Number} lineIndex
     */
    _renderChars: function (method, ctx, line, left, top, lineIndex) {
        this._lastDrawnData = [];

        // set proper line offset
        var lineHeight = this.getHeightOfLine(lineIndex);
        var info;

        ctx.save();
        top -= (lineHeight * this._fontSizeFraction) / this.lineHeight;

        ctx.textAlign = this.textAlign;
        ctx.textJustify = this.textAlign === 'justify';
        ctx.pathColor = this.pathColor;
        ctx.pathWidth = this.pathWidth;
        ctx.convex = this.convex;
        ctx.tracking = this.tracking;
        ctx.minSizePx = this.minSizePx;
        ctx.maxSizePx = this.maxSizePx;
        ctx.a = this.horizontalDiameter / 2;
        ctx.b = this.verticalDiameter / 2;
        ctx.startAngle = this.startAngle;
        ctx.endAngle = this.endAngle;
        ctx.startArcOffset = this._startArcOffset;
        ctx.endArcOffset = this._endArcOffset;
        ctx.maxTextArcLength = this._maxTextArcLength;
        ctx.pathLength = this._pathLength;
        ctx.wrapDistanceAroundPath = this._wrapDistanceAroundPath;
        ctx.atanTan = this._atanTan;

        ctx.font = fabric.Text.prototype._getFontDeclaration.call(
            this,
            {
                fontFamily: this.fontFamily,
                fontSize: this.maxSizePx,
                fontWeight: this.fontWeight,
                fontStyle: this.fontStyle
            },
            false
        );

        const innerText = applyInnerText(line.join(''), this.betweenCharacters, this.betweenWords);
        const textData = ctx.textPath((this.prefix || '') + innerText + (this.suffix || ''), this.pathProperties);

        this._lastDrawnData = textData.pathsData;

        this.fontSize = textData.fontSize;

        ctx.restore();
        return info;
    },

    getTextPaths: function (safeGuardWidth = 0, safeGuardHeight = 0) {
        const containerW = this.width;
        const containerH = this.height;

        const applyPathsOffset = (paths, extraOffsetX = 0, extraOffsetY = 0) => {
            for (var n = 0; n < paths.length; ++n) {
                var path = paths[n];
                var offsetX = path.offsetX + extraOffsetX;
                var offsetY = path.offsetY + extraOffsetY;

                for (var i = 0; i < path.commands.length; i += 1) {
                    var cmd = path.commands[i];
                    if (cmd.type === 'M' || cmd.type === 'L') {
                        cmd.x += offsetX;
                        cmd.y += offsetY;
                    } else if (cmd.type === 'C') {
                        cmd.x += offsetX;
                        cmd.y += offsetY;
                        cmd.x1 += offsetX;
                        cmd.y1 += offsetY;
                        cmd.x2 += offsetX;
                        cmd.y2 += offsetY;
                    } else if (cmd.type === 'Q') {
                        cmd.x += offsetX;
                        cmd.y += offsetY;
                        cmd.x1 += offsetX;
                        cmd.y1 += offsetY;
                    }
                }
            }

            return paths;
        };

        const svgPaths = [];
        if (this._lastDrawnData) {
            for (let n = 0; n < this._lastDrawnData.length; n++) {
                const data = this._lastDrawnData[n];
                const offsetX = data.x + this.width / 2 + safeGuardWidth / 2;
                const offsetY = data.y + this.height / 2 + safeGuardHeight / 2;
                const angle = fabric.util.radiansToDegrees(data.angle);

                const paths = applyPathsOffset([data.path], offsetX, offsetY);
                const pathData = paths[0].toPathData(8);
                svgPaths.push({
                    path: pathData,
                    angle: angle,
                    x: offsetX,
                    y: offsetY
                });
            }

            return {
                pathsData: svgPaths,
                width: containerW + safeGuardWidth,
                height: containerH + safeGuardHeight
            };
        }
        return null;
    },

    /**
     * measure and return the width of a single character.
     * possibly overridden to accommodate different measure logic or
     * to hook some external lib for character measurement
     * @private
     * @param {String} char to be measured
     * @param {Object} charStyle style of char to be measured
     * @param {String} [previousChar] previous char
     * @param {Object} [prevCharStyle] style of previous char
     */
    _measureChar: function (_char, charStyle, previousChar, prevCharStyle) {
        // first i try to return from cache
        var fontCache = this.getFontCache(charStyle),
            fontDeclaration = this._getFontDeclaration(charStyle),
            previousFontDeclaration = this._getFontDeclaration(prevCharStyle),
            couple = previousChar + _char,
            stylesAreEqual = fontDeclaration === previousFontDeclaration,
            width,
            coupleWidth,
            previousWidth,
            fontMultiplier = charStyle.fontSize / this.CACHE_FONT_SIZE,
            kernedWidth;
        var height = charStyle.fontSize;

        if (previousChar && fontCache[previousChar]) {
            previousWidth = fontCache[previousChar];
        }
        if (fontCache[_char]) {
            kernedWidth = width = fontCache[_char];
        }
        if (stylesAreEqual && fontCache[couple]) {
            coupleWidth = fontCache[couple];
            kernedWidth = coupleWidth - previousWidth;
        }
        if (!width || !previousWidth || !coupleWidth) {
            var ctx = this.getMeasuringContext();
            // send a TRUE to specify measuring font size CACHE_FONT_SIZE
            this._setTextStyles(ctx, charStyle, true);
        }
        if (!width) {
            var info = _measureTextOpentype.call(ctx, _char);
            kernedWidth = width = info.width;
            height = info.height;
            fontCache[_char] = width;
        }
        if (!previousWidth && stylesAreEqual && previousChar) {
            previousWidth = _measureTextOpentype.call(ctx, previousChar).width;
            fontCache[previousChar] = previousWidth;
        }
        if (stylesAreEqual && !coupleWidth) {
            // we can measure the kerning couple and subtract the width of the previous character
            coupleWidth = _measureTextOpentype.call(ctx, couple, true).width;
            fontCache[couple] = coupleWidth;

            kernedWidth = coupleWidth - previousWidth;
            // try to fix a MS browsers oddity
            if (kernedWidth > width) {
                var diff = kernedWidth - width;
                fontCache[_char] = kernedWidth;
                fontCache[couple] += diff;
                width = kernedWidth;
            }
        }
        return { width: width * fontMultiplier, kernedWidth: kernedWidth * fontMultiplier, height: height };
    },

    getFlip: function () {
        return { flipX: false, flipY: false };
    },

    // first interation for stroke color
    setOutlineColor: function (color) {
        this.set('opentypeStroke', color || '#000000');
        this.set('stroke', color || '#000000');
    },

    // TODO: refactor in the other interaction to match with engraver
    setStroke: function (stroke) {
        this.set('stroke', stroke);
    },

    setStrokeWidth: function (width) {
        this.set('strokeWidth', width);
    },

    setOutlineWidth: function (width) {
        this.set('opentypeStrokeWidth', width || 0);
    },

    setTrackingAmount: function (tracking) {
        this.set('tracking', tracking || 0);
    },

    getOutlineWidth: function () {
        return this.opentypeStrokeWidth || this.strokeWidth || 0;
    },

    getOutlineColor: function () {
        return this.opentypeStroke || this.stroke || '#000000';
    },

    setFlip: function (flipX, flipY) {
        // not working
        // this.originalFlipX = flipX;
        // this.originalFlipY = flipY;
        // this.set('flipX', flipX);
        // this.set('flipY', flipY);
    },

    forceFontSize: function (size) {
        console.warn('forceFontSize not implemented for PathIText', size);
    },

    toObject: function (propertiesToInclude) {
        const additionalProperties = [
            'pathWidth',
            'pathColor',
            'startAngle',
            'endAngle',
            'centeredRotation',
            'textAlign',
            'skewX',
            'skewY',
            'lockSkewingX',
            'lockSkewingY',
            'lockScalingFlip',
            'fontSize',
            'horizontalDiameter',
            'verticalDiameter',
            'convex',
            'caps',
            'fontPath',
            'fontName',
            'fontFamily',
            'fill',
            'color',
            'stroke',
            'strokeWidth',
            'id',
            'uuid',
            'fontsMap',
            'fontColorsMap',
            'outlineColorsMap',
            'outlineColorOption',
            'zIndex',
            'fontLibraryId',
            'colorLibraryId',
            'evented',
            'selectable',
            'opentypeStroke',
            'locked',
            'visible',
            'name',
            'text',
            'fontColorOption',
            'fontOption',
            'prefix',
            'suffix',
            'betweenCharacters',
            'betweenWords',
            'referenceId',
            'groupId',
            'pageEpsId',
            'flipX',
            'flipY',
            'tracking'
        ].concat(propertiesToInclude);

        return this.callSuper('toObject', additionalProperties);
    }
});

fabric.PathIText.fromObject = function (object, callback) {
    const newObject = new fabric.PathIText(object.text, object);
    callback(newObject);
};
